module.exports = __webpack_public_path__ + "img/gp_main04.6dd9ee0b.png";